exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-28870140]{min-height:calc(100vh - 50px);width:100%;position:relative;overflow:hidden}.fixed-header+.app-main[data-v-28870140]{padding-top:50px}.hasTagsView .app-main[data-v-28870140]{min-height:calc(100vh - 84px)}.hasTagsView .fixed-header+.app-main[data-v-28870140]{padding-top:84px}\n", ""]);

// exports
